import React from "react"
import Modal from "@mui/material/Modal"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Fade from "@mui/material/Fade"
import Button from "@mui/material/Button"

import close_icon from "../../assets/images/close_icon_new.svg"
import styles from "./muiModal.module.scss"

type Props = {
    open: boolean
    onClose: () => void
    children: React.ReactElement
    width: string
    header?: string | React.ReactElement
    subHeader?: string
    headerTextColor?: string
    showFooter?: boolean
    maxHeight?: string
    onSave?: () => void
    submitButtonText?: string
    submitButtonFullWidth?: boolean
    submitButtonDisabled?: boolean
    showCloseIcon?: boolean
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "8px",
    outline: "none",
}

const MuiModal = (props: Props) => {
    return (
        <Modal closeAfterTransition open={props.open} onClose={props.onClose}>
            <Fade in={props.open}>
                <Box sx={{ ...style, width: props.width }}>
                    {(props.header || props?.showCloseIcon) && typeof props.header === "string" ? (
                        <Box
                            className={styles.header}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center">
                            <Box lineHeight={"12px"}>
                                <Typography className="text-15 weight-500" color={props.headerTextColor}>{props.header}</Typography>
                                {props.subHeader && (
                                    <Typography variant="caption" fontWeight="400" color="statiqOrange">
                                        {props.subHeader}
                                    </Typography>
                                )}
                            </Box>
                            <img src={close_icon} alt="close_icon" onClick={props.onClose} />
                        </Box>
                    ) : (
                        props.header
                    )}
                    <Box maxHeight={props.maxHeight || "700px"} overflow={"auto"} className={styles.modalContent}>
                        {props.children}
                    </Box>
                    {props.showFooter && (
                        <Box className={styles.footer} display={"flex"} gap={"8px"} justifyContent={"flex-end"}>
                            <Button variant="light" onClick={props.onClose} fullWidth={props.submitButtonFullWidth}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="statiqOrange"
                                onClick={props.onSave}
                                fullWidth={props.submitButtonFullWidth}
                                disabled={props.submitButtonDisabled}>
                                {props.submitButtonText || "Submit "}
                            </Button>
                        </Box>
                    )}
                </Box>
            </Fade>
        </Modal>
    )
}

export default MuiModal
